import { pushNotification } from './push'
import { makeDismissNotification } from './application/dismiss-notification'
import { notificationsAdapter, notifications$ } from './store'

const dismissNotification = makeDismissNotification(notificationsAdapter)
const markNotificationRead = (id: string) => notificationsAdapter.markRead(id)
const markNotificationArchived = (id: string) => notificationsAdapter.markArchived(id)
const markAllNotificationsRead = () => notificationsAdapter.markAllRead()
const archiveAllNotifications = () => notificationsAdapter.archiveAll()

export { pushNotification, dismissNotification, markNotificationRead, markNotificationArchived, markAllNotificationsRead, archiveAllNotifications, notifications$ }
export type { Notification, NotificationInput, NotificationLevel, NotificationVariant, NotificationStatus } from './domain/notification'
